/**
 * ...
 * @author Robert Lombardo, Wakefield Studios ( rob@wakefield-studios.com )
 */
module.exports = {
    tag: 'sleek',
    quality: 0.4,
    dexterity: 2,
    dodgeChance: 1.0
}